
export default {
  router: {
    index: {
      home: '首页',
      pageSearch1: '用户查询管理',
      pageSearch2: '用户查询',
      pageRoom1: '房间管理',
      pageRoom2: '房间查询',
      pageAppealHall: '申诉大厅',
      refundDetail: '退款查询',
      pageMoreIp: '查看更多ip',
      pageMachine1: '机器举报',
      pageMachine2: '机器举报列表',
      pageUser1: '用户举报',
      pageUser2: '用户举报列表',
      pageApplicatId1: '申请ID',
      pageApplicatId2: 'ID升级查询',
      pageBg: '房间背景审核',
      roomColumn:'Banner管理',
      pageActivity: '活动审核',
      pageGroup: '群组审核',
      reportReview:'举报审核',
      pageProblem: '客服工作站',
      pageProblem1: 'Feedback回复',
      pageProblem2: '问题统计详情',
      pageService1: '工作统计及账号管理',
      pageService2: '客服工作统计列表',
      pageKnowledge1: '热门QA管理',
      pageKnowledge2: '客服知识库',
      pageAccout1: '客服账号管理',
      pageAccout2: '客服账号管理列表',
      pageFamily1: '家族信息查询',
      pageFamily2: '家族查询',
      pageFamily3: '家族成员列表',
      groupManagement: '群组管理',
      pageSearch4:'群组详情',
      login: '登录',
      pageAccount1: '管理员账号设置',
      pageAccount2: '系统帐号设置',
      pageManagement1: '角色权限管理',
      pageManagement2: '角色权限设置',
      pageSuperTube1: '管理员',
      pageSuperTube2: '超级管理员',
      pageSuperTube3: '国家管理员',
      pageQsBank1: '问题库',
      pageQsBank2: '客服知识库',
      pageLost1: '丢单信息查询',
      pageLost2: '丢单信息查询列表',
      community: 'Square社区管理',
      topicManagement: '官方话题管理',
      topicReview: '用户话题审核',
      contentReview: '发帖审核',
      reportManagement: '举报管理',
      auditorManagement: '审核人员管理',
      anomaly: '社区异常操作上报',
      postingPermiss: '发贴条件设置',
      statistics: '日常统计',
      annualCeremony: '年度盛典',
      broadcastManagement: '广播审核 ',
      avatarReview: '头像审核',
      avatarReviewDetail: '头像审核详情',
      albumReview: '相册审核',
      cstStatistics: 'CST工作统计',
      omtStatistics: 'OMT工作统计',
      operationLog: '操作日志',
      loginFeedback1: '登录反馈',
      loginFeedback2: '登录反馈列表',
      loginFeedback3: '登录反馈详情',
      systemBlacklist1: '账号黑名单',
      systemBlacklist2: '账号黑名单列表',
      activitySuppor: '活动扶持统计',
      couplePage1: 'Couple 活动入口',
      nowMemberInroom1: '用户当前所在房间',
      nowMemberInroom2: '用户当前所在房间',

      error401: 'error 401',
      error404: 'error 404',
      error500: 'error 500',
    },
    router: {
      beforeClose: {
        sureClose: '确定要关闭这一页吗',
      },
    },
  },

  views: {
    platform: {
      tab1: '月统计',
      tab2: '日统计',
      tab3: '充值明细',
      tab4: '金币消耗月统计',
      tab5: '金币消耗日统计',
      tab6: '任务完成明细',
      tab7: '任务统计',
      tab8: '充值次数查询',
      tab9: '代理充值明细',
      tab10: '退款明细',
      tab11: '冻结明细',
      tab1Sub1: '当日数据延迟30分钟左右计算',
      tab1Sub2: '当月数据延迟30分钟左右计算',

      platformRechargeDetail1: '充值到账时间',
      platformRechargeDetail2: '到账用户id',
      platformRechargeDetail3: '到账用户姓名',
      platformRechargeDetail4: '到账金额',
      platformRechargeDetail5: '金币数量',
      platformRechargeDetail6: '币种',
      platformRechargeDetail7: '充值类型',
      platformRechargeDetail8: '订单号',
      platformRechargeDetail9: '金额降序',
      platformRechargeDetail10: '金额升序',
      platformRechargeDetail11: '支付类型',
      platformRechargeDetail12: '排序',

      platformGoldMonth: '年月',

      platformGoldDay1: '日期',
      platformGoldDay2: '礼物消费',
      platformGoldDay3: '猜拳消费',
      platformGoldDay4: '成为房间会员',
      platformGoldDay5: '全服喇叭',
      platformGoldDay6: '召唤粉丝',
      platformGoldDay7: '召唤会员',
      platformGoldDay8: '房间置顶',
      platformGoldDay9: '房间加锁',
      platformGoldDay10: '创建房间',
      platformGoldDay11: '创建家族',
      platformGoldDay12: '任务奖励',
      platformGoldDay13: '商城购买',
      platformGoldDay14: '其它',
      platformGoldDay15: 'pk消耗',
      platformGoldDay16: '投票消耗',

      platformDetail: '用户ID',

      platformTask1: '日期',
      platformTask2: '上麦10分钟',
      platformTask3: '上麦1小时',
      platformTask4: '分享房间一次',
      platformTask5: '发起PK',
      platformTask6: '送出3个礼物',
      platformTask7: '任意等级5级',
      platformTask8: '任意等级10级',
      platformTask9: '创建房间',
      platformTask10: '发布活动',
      platformTask11: '组成CP',
      platformTask12: '创建家族',
      platformTask13: '首冲',
      platformTask14: '合计',

      platformRecharge1: '到账用户id',
      platformRecharge2: '到账用户姓名',
      platformRecharge3: '到账总金额(美元)',
      platformRecharge4: '总充值次数',

      payType1: '微信',
      payType2: '支付宝',
      payType3: '苹果支付',
      payType4: '谷歌支付',
      payType5: 'palpay支付',
      payType6: '代理充值',
      payType7: '代理内部充值',
      payType8: '电商充值',
      payType9: 'payssion支付',
      payType10: 'tap支付',
      payType11: '华为支付',
      // payType12: '茄子快传支付',
      payType12: 'payermax支付',
      payType13: 'dlocal充值',
      payType14: 'paypal充值',
      payType15: 'checkout充值',

      payWay1: '人民币',
      payWay2: '美元',

      agentTableText1: '代理靓号',
      agentTableText2: '用户ID',
      agentTableText3: '注册时间',
      agentTableText4: '头像',
      agentTableText5: '昵称',
      agentTableText6: '充值金币',
      agentTableText7: '充值金额（美元）',
      agentTableText8: '充值时间',

      table5Text1: '退款人',
      table5Text2: '退款时间',
      table5Text3: '订单号',
      table5Text4: '用户靓号',
      table5Text5: '请输入用户靓号',
      table5Text6: '退款金币数(美金数)',
      table5Text7: '昵称',
      table5Text8: '国家',
      table5Text9: '注册时间',
      table5Text10: '等级(财富/魅力/活跃)',
      table5Text11: '账户金币余额',
      table5Text12: '谷歌/苹果充值总额',
      table5Text13: '封禁至',
      table5Text14: '永久封禁',
      table5Text15: '注册IP',
      table5Text16: '国家',
      table5Text17: '累积退款金额',
      table5Text18: '冻结',
      table5Text19: '未冻结',
      table5Text20: '是否冻结',
      table5Text21: '充值时间',
      table5Text22: '谷歌以扫描时间为准，苹果以收到通知时间为准',
      table5Text23: '累积退款金额',
      table5Text24: '状态',
      table5Text25: '已支付',
      table5Text26: '未支付',
      table5Text27: '还款操作',
      table5Text28: '当前国家',
      table5Text29: '还款时国家',

      table6Text1: '冻结账户',
      table6Text2: '冻结金币数（美金数）',
      table6Text3: '昵称',
      table6Text4: '国家',
      table6Text5: '最近退款金额',
      table6Text6: '注册IP',
      table6Text7: '等级(财富/魅力/活跃)',
      table6Text8: '账户金币余额',
      table6Text9: '充值总额',
      table6Text10: '冻结时间',
      table6Text11: '订单号',
      table6Text12: '注册时间',
      table6Text13: '冻结操作员',
      table6Text14: '冻结明细',
      table6Text16: '冻结时间',
      table6Text17: '修改备注',
      table6Text18: '还款渠道',
      table6Text19: '还款单号',
      table6Text20: '金币数',
      table6Text21: '扣除金币数',


      table6Text15: '最近一次警告时间',

    },

    public: {

      quickReview: '快速审核',
      reviewTxt: '当前共审核项目:{total},通过:{pass},重置资料:{Refused}',
      attention: '*勾选的为重置资料，不勾选的为同意通过',
      reviewTxt_1: '当前共审核项目:{total},通过:{pass},删除:{Refused}',
      attention_1: '*勾选的为删除，不勾选的为同意通过',
      operatSuccess: '操作成功',
      operatError: '操作失败',
      pass: '通过',
      refuse: '拒绝',
      passed: '已通过',
      noPass: '不通过',
      refused: '已拒绝',
      close: '关闭',
      submit: '提交',
      yes: '是',
      no: '否',
      sure: '确定',
      cancel: '取消',
      prompt: '提示',
      operation: '操作',
      add: '添加',
      delete: '删除',
      edit: '编辑',
      query: '查询',
      update: '修改',
      turkish: '土耳其语',
      arabic: '阿语',
      indonesian: '印尼语',
      en: '英语',
      vietnam: '越南',
      thailand: '泰国',
      india: '印地',
      spanish: '西语',
      portugal: '葡萄牙',
      all: '全部',
      noPermission: '暂无权限',
      pleaseChoose: '请选择',
      choose: '选择',

      none: '无',
      sex: '色情/性',
      curse: '侮辱谩骂',
      religion: '不尊重宗教',
      terroristActivities: '恐怖活动',
      violationOfLaw: '违法违规',
      propaganda: '宣传其他App',
      resetHeadImg: '重置头像',
      search: '搜索',

      confirmOpear: '确认执行该操作',

      confirmDelete: '确认执行删除操作',
      confirmReset: '确认执行重置资料',
      confirmBanDev: '确认执行封禁设备',
      confirmBan: '确认执行封禁操作',
      confirmIgnore: '确认执行检查通过操作',
      confirmPass: '确认执行通过操作',
      confirmRefuse: '确认执行拒绝操作',
      confirmMute: '确认执行禁言操作',
      confirmUnMute: '确认执行解除禁言操作',
      confirmRecommend: '确认执行推荐操作',
      confirmShenPost: '确认执行沉贴操作',
      confirmShield: '确认执行屏蔽操作',
      confirmUpRack: '确认执行上架操作',
      confirmDownRack: '确认执行下架操作',
      confirmUnbanBoard: '确认执行解禁广播操作',
      confirmCancelScreen: '确认执行取消屏蔽操作',

      noneData: '暂无数据',
      operatSuccessUpdate: '操作成功，更新状态中',
      pleaseChooseTarget: '请选择操作对象',
      chooseAll: '全选',
      permanentBan: '永久封禁',
      toText: '至',
      showBigImg: '查看大图',
      export: '导出',
      chooseTime: '请选择时间',
      startTime: '开始时间',
      endTime: '结束时间',
      enterStartTime: '请输入开始时间',
      enterEndTime: '请输入结束时间',
      date: '日期',
      ignoreText: '忽略',
      waitAudit: '待审核',

      batchDelete:'批量删除',
      download_template:'模板下载',

      null:'无',
      chooseImg:'选择图片',
      clear:'清除',

      warnDel:'警告并拒绝',
      region:'区域',

      to:'至',

      reportedPerson:'被举报者',
      reporter:'举报者',
    },
    userInformation: {
      enterId: '请输入用户靓号id',
      userId: '用户靓号',
      invalidId: '输入的id无效',
      noUser: '未找到该用户',
      search: '查询',
    },
    problems: {
      startTime: '开始时间',
      endTime: '结束时间',
      enterUserId: '请输入用户ID',
      enterCSId: '请输入客服ID',
      search: '搜索',
      export: '导出',
      unanswered: '待回复',
      answered: '已回复',
      closed: '已关闭',
      detail: '查看详情',
      userId: '用户ID',
      CSId: '客服ID',
      status: '状态',
      qsType: '问题类型',
      userRate: '用户评分',
      nickname: '用户昵称',
      processorID: '处理人ID',
      qsDescript: '问题描述',
      language: '语言',
      createTime: '创建时间',
      answerTime: '回复时间',
      oneStar: '1星',
      twoStar: '2星',
      threeStar: '3星',
      fourStar: '4星',
      fiveStar: '5星',
      endMoreStar: '结束时间大于开始时间',
      chooseTime: '请选择时间',
      pleaseChoose: '请选择',
      text1: 'Feedback统计',
      text2: '客服账号统计',
      text3: '关闭问题',
      text4: '回复问题',
      text5: '批量关闭问题',
      text6: '批量回复问题',
      text7: '确认结束所选的feedback?',
      text8: '回复人',
      text9: '回复时间',
      text10: '回复内容',
      text11: '编辑人',
      text12: '编辑时间',
      text13: '复用次数↑↓',
      text14: '最近使用时间↑↓',
      text15:'确认以当前答案回复？',
      text16:'知识库',
      text17:'最近使用',
      text18:'关闭时间',

      level:'等级(财富/魅力/活跃/SVIP)',
    },
    activityReview: {
      examinaPassed: '审核通过',
      examinaNotPassed: '审核不通过',
      sureOperat: '确认执行通过操作？',
      sureRefuse: '确认执行拒绝操作',
      sureDelete: '确认执行删除操作？',
      userId: '用户靓号',
      roomLiangId: '房间靓号id',
      enterRoomId: '请输入房间靓号id',
      userIdInvalid: '输入的id无效',

      unReview: '未审核',
      reviewed: '已审核',
      chooseAll: '全选',
    },
    appealHall: {
      allIp: '查看所有ip',
      hasAccount: '共有{num}个账号',
      enterId: '请输入用户靓号id',
      search: '查询',
      userId: '用户靓号',
      userIdInvalid: '输入的id无效',
      tabText1: '申诉列表',
      tabText2: '申诉数量>=50的列表',
      tabText3: 'SVIP用户解封记录',
      frozenId: '被封禁用户靓号',
    },
    moreUserUpList: {
      chooseAll: '全选',
      banAll: '全部封禁',
      banChooseUser: '封禁所选用户',
      choose: '选择',
      sureBanAll: '确认全部封禁',
      enterBanUser: '请选择需要封禁的用户',
      sureBanUser: '确认封禁用户',
      banTimeTo: '封禁时间到',
      permanentBan: '永久封禁',
      enterUserId: '请输入用户ID',
      search: '查询',
    },
    application: {
      enterUserId: '请输入用户靓号id',
      userId: '用户靓号',
      userIdInvalid: '输入的id无效',
      surePassOperat: '确认执行通过操作？',
      sureRefuseOperat: '确认执行拒绝操作？',
      unReview: '未审核',
      reviewed: '已审核',
      table1Text1: '申请时间',
      table1Text2: 'ID',
      table1Text3: '头像',
      table1Text4: '财富等级/充值勋章',
      table1Text5: '兑换ID',
      table1Text6: '原有ID',
      table1Text7: '兑换ID',
      originalId:'原有ID'
    },
    backgroundReview: {
      showBigImg: '查看大图',
      refuseReason: '请填写拒绝理由',
      moreRefuseReason: '请输入拒绝理由，最多可输入500字',
      error: '错误',
      surePassOperat: '确认执行通过操作？',

      unReview: '未审核',
      reviewed: '已审核',
      text: '已拒绝',
      text3: '已通过',
      chooseAll: '全选',
      reviewTime: '审核时间',
      roomId: '房间ID',
      roomLiangId: '房间靓号id',
      enterRoomId: '请输入房间靓号id',
      rejectTime: '拒绝时间',
      passTime: '通过时间',
      operatName: '操作人',
      waitTime: '等待时长',
      applicationTime: '申请时间',
      text1: '申请人',

      text2:'请选择房间',
    },
    page401: {
      content: 'Oh~~您没有浏览这个页面的权限~',
    },
    page404: {
      content: 'Oh~~您的页面好像飞走了~',
    },
    page500: {
      content: 'Oh~~鬼知道服务器经历了什么~',
    },
    backBtnGroup: {
      backHome: '返回首页',
      backLast: '返回上一页',
    },
    familyInfomation: {
      enterId: '请输入家族id/族长id',
      search: '查询',
      allMember: '查看家族成员',
      ban24: '封禁24小时',
      ban72: '封禁72小时',
      ban30D: '封禁30天',
      permanentBan: '永久封禁',
      familyOrTeamId: '家族id/族长id',
      familyId: '家族ID',
      familyName: '族名',
      patriarchName: '族长靓号',
      familyImg: '家族头像',
      member: '成员人数',
      level: '家族等级',
      point: '家族收到金币',
      wealthClass: '财富等级',
      charmLevel: '魅力等级',
      ratio: '分成比例',
      familyIdS: '家族id',
      teamId: '组长id',
      fiveM: '5分钟',
      oneH: '1小时',
      twoH: '2小时',
      twelveH: '12小时',
      sureUnBan: '确定解除封禁',
      enterInvalid: '输入的id无效',
      unSearch: '未查询到该数据',
      sureDelete: '确认执行删除操作？',
      disband: '解散',
    },
    familyDissolution: {
      familySearch: '家族查询',
      dissolution: '家族解散申请',
      familyId: '家族ID',
      familyName: '族名',
      familyImg: '家族头像',
      ownerId: '族长ID',
      nickname: '族长昵称',
      level: '家族等级',
      starLevel: '家族星级',
      number: '成员数',
      addTime: '申请时间',
      dissolutioned: '已解散',
      ignore: '忽略',
      ignored: '已忽略',
      dissolutionFam: '解散家族',
      checkDissolut: '确认执行解散家族操作',
      checkIgnore: '确认执行忽略操作',
    },
    homeDetail: {
      familyInfo: '家族信息',
      familyId: '家族id',
      familyName: '家族名称',
      familyImg: '家族头像：',
      chooseImg: '选择图片',
      clear: '清除',
      declarat: '家族宣言',
      isFamily: '是否为星际家族',
      ratio: '分成比例',
      ratioValue: '百分比：请输入0-100之间的数值',
      level: '家族等级',
      strengthLevel: '财富实力等级',
      charismaLevel: '魅力实力等级',
      queryFail: '查询数据失败',
      nameNoNot: '家族名称不能为空',
      resetInfo:'重置资料',
      sureResetInfo:'确认重置家族资料吗？',
    },
    familyMember: {
      enterUserId: '请输入成员id',
      search: '查询',
      confidential: '保密',
      male: '男',
      female: '女',
      userId: '成员id',
      familyId: '家族成员靓号ID',
      nickname: '成员昵称',
      gender: '性别',
      headImg: '成员头像',
      contributionToday: '今日贡献(钻石)',
      contributionMonth: '本月贡献(钻石)',
      enterInvalid: '输入的id无效',
      sureDelete: '确认删除该家族成员？',
      role:'身份',

    },
    faqDate: {
      module: '模块',
      chooseType: '请选择问题类型',
      language: '语言',
      qs: '问题',
      answer: '回答',
      img: '照片',
      sureUpdate: '确认修改',
      noneNotice: '问题或回答不能为空',
      jumpLink: '跳转链接',
    },
    knowledgeList: {
      chooseType: '请选择问题类型',
      add: '添加',
      prompt: '提示',
      module: '模块',
      sureDelete: '确认删除？',
      sort: '排序',
      type: '类型',
      qs: '问题',
      answer: '回答',
      image: '图片',
      time: '时间',
      chooseImg: '选择图片',
      clear: '清除',
      permanentBan: '永久封禁',
    },
    login: {
      title: '多国客服管理系统',
      loginWarn: '你的账号在别处进行过登陆，建议修改密码',
    },
    machineReport: {
      selectAll: '全选',
      enterUserId: '请输入用户靓号id',
      inTotal: '共有{num}个账号',
      content: '举报内容：',
      image: '举报图片：',
      userId: '用户靓号',
      enterIdInvalid: '输入的id无效',
      banUser: '封禁用户成功',
      ignore: '确认忽略举报信息？',
      tabText1: '机器举报记录',
      tabText2: '封禁记录',
      // ignored: '已忽略',
      ignored: '已检查通过',
      reseted: '已重置资料',
      banDeviced: '封禁设备',
      banIdTo: '封禁id',
      resetData: '重置资料',
      banId: '封禁id',
      banDevice: '封禁设备',
      // ignore: '忽略',
      ignore: '检查通过',
    },
    problemsDetail: {
      userId: '用户id',
      nickname: '用户昵称',
      customerID: '客服ID',
      customerNickname: '客服昵称',
      qs: '问题',
      language: '语言',
      qsImg: '问题图片',
      prompt: '抱歉!您的浏览器不支持视频标签',
      type: '类型',
      answer: '回复',
      answerImg: '回复图片',
      status: '状态',
      rate: '评分',
      unanswered: '未回复',
      answered: '已回复',
      orderNum: '订单号',
      chooseMediaText: '选择最多五张图片或一份视频上传',
      mostImgText: '最多上传五张图片',
      mostVideoText: '最多上传一份视频',
      text: '选择快捷回复',
      text1: '发送回复',
      text2: '回复内容不能为空！',
      text3: '回复后关闭问题',

      inTotal:'共有{num}个账号',
    },
    roomManagement: {
      enterRoomId: '请输入房间靓号id',
      roomId: '房间靓号id',
      enterIdInvalid: '输入的id无效',
      notFoundRoom: '未找到该房间',
      ban24: '封禁24小时',
      ban72: '封禁72小时',
      ban30D: '封禁30天',
      permanentBan: '永久封禁',
      tabText1: '房间信息查询',
      tabText2: '房间解散恢复',
    },
    auditManageDisband: {
      roomId: '房间ID',
      roomName: '房间名称',
      roomImg: '房间头像',
      owerId: '房主ID',
      nickname: '房主昵称',
      level: '房间等级',
      hot: '房间热度',
      currentMonth: '当周流水',
      application: '申请时间',
      roomLiangId: '房间靓号',
      ignore: '忽略',
      dismiss: '解散房间',
      checkIgnore: '确认忽略该房间解散申请',
      checkDismiss: '确认解散该房间',
      deleted: '已解散',
      ignored: '已忽略',
      cost: '房间流水',
      hmeownerId: '房主靓号',
      recoverRoom: '恢复房间',
      confirmRecovery: '确定恢复',
      confirmRecoveryTitle: '确定恢复该房间？',
      roomCostMoney: '房间总流水',
      disbandTime: '解散时间',
    },
    roomDetail: {
      title: '标题',
      content: '内容',
      roomId: '房间靓号',
      ban: '封禁',
      roomName: '房间名称',
      roomImg: '房间头像：',
      bg: '背景图片：',
      expirationDate: '有效期',
      tags: '标签',
      level: '房间等级',
      roomOwnerId: '房主id',
      updateNickname: '修改房间昵称',
      nicknameUnNone: '昵称不能为空',
      sureBanRoom: '确认封禁该房间',
      sureUnbanRoom: '确认解封该房间',
      liftTheBan: '解除封禁',
      chooseTime: '选择封禁时间',
      permanentBan: '永久封禁',
      roomBlacklist: '房间黑名单',
      userId: '用户ID',
      userNickname: '用户昵称',
      deleteUser: '剔除',
      checkDeleteUser: '确定将用户{username}从黑名单中移除吗?',
      editRoomNumT: '原房间靓号: {roomNum}',
      editRoomId: '修改房间靓号',
      roomIdNotNull: '房间靓号不能为空',
      roomIdIsNum: '房间靓号应为数字',
      resetRoomInfo: '重置房间信息',
      resetRoomWarn: '确认执行重置房间信息操作',

      recedon:'最近冻结记录',
      userLv: "用户等级(财富/魅力/活跃)",
    },
    serviceManagement: {
      add: '新增',
      info: '客服信息',
      customerID: '客服ID',
      enterCustomerID: '请输入客服ID',
      language: '语言',
      prompt: '提示',
      sureDelete: '确定删除吗？',
      today: '24小时回复数',
      Ttoday: '3天内回复数',
      week: '7天内回复数',
      month:'本月回复数',
      lastMonth:'上月回复数',
      weekRate: '7日评分',
      rateNum: '评分条数',
      enterLanguage: '请输入语言',
      text1:'客服ID',
      text2:'客服账号名',

      nickname:'昵称',
      country:'国家',
      loginTime:'最后登录时间',
    },
    giftList: {
      startEndTime: '结束时间要大于开始时间'
    },
    user_data: {
      freezeMoney: '冻结消费',
      unFreezeMoney: '解除冻结',
      sureFreeze: '确定冻结消费？',
      sureUnFreeze: '确定解除冻结',
      title: '标题',
      content: '内容',
      number: '靓号',
      addItem: '新增道具',
      add: '新增',
      setItem: '道具设置',
      endItem: '道具结束',
      headImg: '头像',
      chooseImg: '选择图片',
      clear: '清除',
      nickname: '昵称',
      gender: '性别',
      male: '男',
      confidential: '保密',
      female: '女',
      birthday: '出生日期',
      phone: '手机',
      email: '邮箱',
      country: '国家',
      province: "省份",
      hobby: '爱好',
      tag: '标签',
      sign: '签名',
      familyName: '家族名称',
      rechargeAmount: '充值金额(元)',
      agentRecharge: '代理充值(美元)',
      contribution: '贡献值(金币)',
      charmValue: '魅力值(金币)',
      goldCoin: '金币余量',
      diamond: '钻石余量',
      exchange: '钻石兑换金币的钻石总数',
      registerTime: '注册时间',
      registerIp: '注册IP',
      equipment: '设备',
      equipmentText: '已被封禁，被封账号',
      moreIp: '同IP账号',
      lastLoginTime: '最后登录时间',
      monthEarnings: '本月收益',
      lastMonthEarnings: '上月收益',
      createRoomId: 'ta创建房间的ID',
      banId: '封禁ID',
      unBanId: '解禁ID',
      banTimeTo: '封禁时间到：',
      permanentBan: '永久封禁',
      ban: '封禁',
      liftTheBan: '解除封禁',
      banEquipment: '封禁设备',
      unBanEquipment: '解禁设备',
      muteText: '禁言',
      muteText_1: '禁言社区',
      unMuteText: '解除禁言',
      checkMute: '确认执行禁言操作',
      checkUnMute: '确认执行解除禁言操作',
      banCount: '封禁次数',
      times: '{counts}次',
      freezeConsumption: '冻结消费',
      freezeing: '正在冻结',
      normal: '正常',
      inMai: '在麦时长',
      wealthClass: '财富等级',
      charmLevel: '魅力等级',
      activeLevel: '活跃等级',
      banReason: '封禁原因',
      itemType: '道具类型',
      items: '道具',
      aging: '时效(天)',
      numOrDate: '数量or有效时长(天)',
      numText: '数量',
      dateText: 'vip天数',
      updateNum: '修改靓号',
      numberId: '靓号id',
      updateNickname: '修改昵称',
      nickname: '用户昵称',
      detailList: '明细列表',
      ban24: '封禁24小时',
      ban72: '封禁72小时',
      ban7D: '封禁7天',
      ban30D: '封禁30天',
      ban90D: '封禁90天',
      vehicle: '座驾',
      medal: '勋章',
      headdress: '头饰',
      number: '靓号',
      VIP: 'VIP',
      hasAccount: '共有{num}个账号',
      authentication: '身份认证',
      day: '天',
      gift: '礼物',
      coupon: '卡券',
      roomMedal: '房间勋章',
      sureUpdateImg: '确定修改头像？',
      sureDeleteItem: '确定删除该道具？',
      enterIdInvalid: '输入的id无效',
      enterNoNone: '昵称不能为空',
      enterReason: '请填写封禁理由',
      sureBanId: '确定封禁id？',
      sureUnBanId: '确定解除该封禁id？',
      sureBanDevice: '确定封禁设备？',
      sureUnBanDevice: '确定解除该封禁设备？',
      setTtem: '设置道具',

      roomDetail: '房间详情',
      showItem: '查看道具',
      itemDetail: '道具详情',

      banBroadcast: "封禁广播",
      sureBanBroadcast: "确定封禁广播？",
      unBanBoard: '解禁广播',
      checkEditCountry: '确认修改国家?',
      showCp: '查看特殊cp关系',
      otherId: '对方靓号',
      typeText: '类型',
      teamTime: '组成关系时间',
      cpDetail: '特殊cp关系',
      level: '等级',
      point: '积分',
      roomText: '房间',

      table2Text1: '次数',
      table2Text2: '封禁类型',
      table2Text3: '封禁理由',
      table2Text4: '封禁时间',
      table2Text5: '操作系统',
      table2Text6: '操作时间',
      table2Text7: '操作角色',
      table2Text8: '操作人员',
      showDetail: '查看详情',
      banHistoryTitle: '封禁人员过往历史',
      roleText1: '后台',
      roleText2: '超管',
      roleText3: '国管',
      passwordText: '密码',
      updatePassword: '修改密码',
      warnPassword: '密码不能为空',
      warnPassword2: '确认执行修改密码操作',
      updatePhone: '修改手机号',
      warnPhone: '输入的手机号不能为空',
      warnPhone2: '确认执行修改手机号操作',
      updateMail: '修改邮箱',
      warnMail: '输入的邮箱不能为空',
      warnMail2: '确认执行修改邮箱操作',
      bandOpt1: '解除qq绑定',
      bandOpt2: '解除微信绑定',
      bandOpt3: '解除Facebook绑定',
      bandOpt4: '解除Google绑定',
      bandOpt5: '解除snapchat',
      warnBind: '确认执行解绑操作',
      unBindText: '解除绑定',
      unBindText2: '解绑',
      resetUser: '重置个人信息',
      warnResetUser: '确认执行重置个人信息操作',
      warnBtnText: '警告',
      warnMarkText1: '警告内容',
      warnMarkText2: '警告原因',
      warnMarkText3: '图片',
      warnMarkText4: '所有输入信息不能为空',
      text1: '删除全部评论',
      text2: '确认该用户删除全部评论？',
      text3: '删除全部帖子',
      text4: '确认该用户删除全部帖子？',
      text5: '个人飘屏',
      text6: '聊天气泡',

      phoneRegion:'绑定区号',
      labelTxt34: "修改区绑定号",

      points:'点数',
      currentPoint:'当前点数',
      freeze:'冻结',
      unfreeze:'解冻',
      donTime: "冻结到期时间",
      donWhy: "冻结原因",

      banGather: "封禁召集",
      unbanGather: "解禁召集",
      sureUnBanGather: "确定解除该封禁的召集？",
      sureBanGather: "确定封禁召集？",

      allequipment: "同设备账号",

      userlevel:'用户等级(财富/魅力/活跃)',
      recharge_money:'总充值',
      credit1:'金币余额',
      credit2:'钻石余额',

      memorandum: "运营备忘",
      addMemo: "添加备忘",
      enterMemoContent: "请输入备忘内容...",

      svipFreezeTitleText:'最近操作记录',
      deTime: "操作时间",
      deman: "操作人",
      freezePoint:'操作点数',
      type: "操作类型",

      banTime: "封禁到期时间",
      banWhy: "封禁原因",
      receban:'最近封禁记录',

      userLevel:'财富/魅力/活跃/SVIP',

      changeGender:'修改性别',
      chooseGender:'选择性别',
      changeCountry:'修改国家省份',
      reason:'修改原因',

      target:'举报对象',
    },

    ip_detail: {
      enterUserId: '请输入用户ID',
      userId: '用户id',
      loginTime: '注册时间',
      loginUser: '注册用户',
      loginIp: '注册ip',
      lastLoginTime: '最后登录时间',

      nickname: '昵称',
      deviceCode: '设备码',
      country: '国家',
      wealth: '财富',
      charm: '魅力',
      activeLevel: '活跃等级',
      banAll: '全部封禁',
      banAll_1: '封禁≤5级小号',
      banChooseUser: '封禁所选用户',

      levelText: '等级',
      refreshList: '刷新列表',
      resetData: '重置个人资料',
      checkResetData: '确认执行重置资料操作?',
      checkResetData1: '确认执行还款操作?',

      unBanDevice:'解禁设备',
    },
    userReport: {
      search: '搜索',
      warning: '警告',
      banTimeTo: '封禁时间到',
      detail: '详情',
      appQs: 'App问题',
      suggest: '建议',
      topUp: '充值',
      sex: '色情',
      harassment: '骚扰',
      spam: '垃圾信息',
      violationOfLaw: '违法违规',
      other: '其他',
      sureBanUser: '确认解封该用户？',
      ignore: '确认忽略举报信息？',
      sureDelete: '确定删除？',
      unBanSuccess: '解封成功',
      banSuccess: '封禁用户成功',
      permanentBan: '永久封禁',

      tabText1: '用户举报列表',
      tabText2: '违规记录',
      tabText3: '忽略记录',
      resetData: '重置资料',
      banId: '封禁id',
      banDevice: '封禁设备',
      // ignore: '忽略',
      ignore: '检查通过',
      chooseAll: '全选',
      // ignored: '已忽略',
      ignored: '已检查通过',
      reseted: '已重置资料',
      banDeviced: '封禁设备',
      banIdTo: '封禁id ',
      banRoomTo: '封禁房间',
      level: '等级',
      registerIp: '注册IP',
      inTotal: '共有{num}个账号',
      selectAll: '全选',
      topUpReport: '充值举报',
      text: '请输入被举报用户/房主靓号'
    },
    account: {
      addAccount: '添加管理员帐号',
      edit: '编辑',
      ban: '禁用',
      unBan: '解除禁用',
      addTo: '已上架',
      unAddTo: '未上架',
      accountId: '管理员ID',
      username: '用户名',
      realname: '真实姓名',
      role: '角色',

      lastLoginTime: '上次登录时间',
      fiveM: '5分钟',
      oneH: '1小时',
      twoH: '2小时',
      twelveH: '12小时',
      sureDelete: '确定删除？',
      sureBanAccount: '是否禁用该账号',
      sureUnBanAccount: '是否解除禁用该账号',
    },
    windDetail: {
      setAccount: '帐号设置',
      username: '用户名',
      newPassword: '新密码',
      checkPassword: '确认密码',
      realname: '真实姓名',
      role: '角色',
    },
    authorityManagement: {
      addRole: '添加角色',
      editRole: '编辑角色',
      editAuthority: '编辑权限',
      roleInfo: '角色信息',
      sort: '序号',
      roleName: '角色名称',
      authority: '权限编辑',
      role: '角色',
      text1: '模块权限管理',
      text2: '模块',
      text3: '运营名称',
      text4: '是否启用',
      text5: '模块权限设置',
      tabText2: '大R充值数据追踪',
      text6: '道具发放限制列表',
      page6Text1: '本月允许发放礼物金币总数',
      page6Text2: '本月允许发放非礼物发放次数',
      page6Text3: '创建时间',
      page6Text4: '修改时间',
      text7: '授权名单',


    },
    menuagement: {
      add: '添加',
      editAuthority: '修改权限',
      menuName: '菜单名称',
      name: '名称',
      back: '返回',
      authorityName: '权限名称',
      sureDeleteMenu: '确认删除该菜单',
      sureDeleteAuthority: '确认删除该权限',
    },
    superTube: {
      enterIdOrKeyword: '请输入靓号id',
      userId: '靓号ID',
      headImg: '头像',
      nickname: '昵称',
      country: '国家',
      lastLoginTime: '上次登录时间',

      adminList: '管理员列表',
      adminGroup: '管理员分组',
      addGroup: '新增分组',
      editGroup: '编辑分组',
      groupId: '组id',
      groupName: '组名',
      remarks: '备注',
      createTime: '创建时间',
      updateTime: '更新时间',
      comfirmDeleteGroup: '确认删除分组？',
      grouping: '分组',
      updateGroup: '修改分组',
      teamNameNoNull: '组名不能为空',

    },
    national: {
      idOrName: '靓号ID',
      enterIdOrKeyword: '请输入靓号id',
      userId: '靓号ID',
      headImg: '头像',
      nickname: '昵称',
      country: '国家',
      lastLoginTime: '上次登录时间',
    },
    lostOrder: {
      startTime: '开始时间',
      endTime: '结束时间',
      dataType: '数据类型',
      orderIdOrUserId: '丢单号/用户ID',
      topUp: '充值',
      gold: '金币',
      date: '日期',
      userId: '用户ID',
      nickname: '用户昵称',
      amountReceived: '到账金额',
      agentRecharge: '代理充值(美元)',
      text1:'总反馈数',
      text2:'回复数',
      text3:'后台回复数',
      text4:'App内回复数',
      text5:'App问题',
      text6:'充值问题',
      text7:'建议',
      text8:'其它',
      text9:'总用户数',
    },

    questionStatistics:{
      text1:'总问题个数',
      text2:'收到回复用户数',
      text3:'总回复次数',
      text4:'后台回复次数',
      text5:'App内回复次数',
      text6:'App问题个数',
      text7:'充值类问题个数',
      text8:'建议类问题个数',
      text9:'其他问题个数',
    },

    questionBank: {
      addQs: '添加问题',
      sureDelete: '确认删除？',
      uploadVideoError: '上传视频的时长不能超过30s',

      importExcel:'导入知识库',
      ChineseRemarks:'中文备注',
      btnText:'视频或图片url',

      uploadSuccess:'上传成功',
    },
    // 0英语 1阿语 2印尼语 3土耳其语 4印地语 5越南语 6泰语
    communityLanguage: {
      language1: '英语',
      language2: '阿语',
      language3: '印尼语',
      language4: '土耳其语',
      language5: '印地语',
      language6: '越南语',
      language7: '泰语',
      language8: '巴西',
      language9: '西语',
      language10: '海湾组',
      language11: '印尼语',
      language12: '葡萄牙',
      language1Area: '英语区',
      language2Area: '阿语区',
      language3Area: '印尼语区',
      language4Area: '土耳其语区',
      language5Area: '印地语区',
      language6Area: '越南语区',
      language7Area: '泰语区',
      language8Area: '巴西区',
      language9Area: '西语区',
      language10Area: '印尼语区',
      language11Area: '葡萄牙语区',
      language12Area: '海湾地区',
    },
    // 暂时不用
    communityLanguage2: {
      language1: '英语',
      language2: '阿语',
      language3: '印尼语',
      language4: '土耳其语',
      language5: '印地语',
      language6: '越南语',
      language7: '泰语',
      language8: '巴西',
      language9: '西语',
      language10: '海湾组',
      language11: '印尼语',
      language12: '葡萄牙',
      language1Area: '英语区',
      language2Area: '阿语区',
      language3Area: '印尼语区',
      language4Area: '土耳其语区',
      language5Area: '印地语区',
      language6Area: '越南语区',
      language7Area: '泰语区',
      language8Area: '巴西区',
      language9Area: '西语区',
      language10Area: '印尼语区',
      language11Area: '葡萄牙语区',
      language12Area: '海湾地区',
    },
    topicManagement: {
      addTopic: '推荐话题',
      addTopic_1: '添加话题',
      // tabText1: '非土语区',
      // tabText2: '土语区',
      tabText1: '英语',
      tabText2: '阿语',
      tabText3: '印尼语',
      tabText4: '土耳其语',
      table1: '排序',
      table2: '话题名称',
      table3: '话题头像',
      table4: '话题介绍',
      table5: '创建时间',
      table10: '推荐结束时间',
      table6: '帖子数',
      table7: '评论数',
      table8: '点赞数',
      table9: '状态',
      table11: '当前话题管理员',
      opera1: '下架',
      opera2: '上架',
      topicName: '话题名称',
      topPlaceholder: '请输入话题名称',
      topicImg: '话题图片',
      chooseImg: '选择图片',
      topicDesc: '话题描述',
      topicSort: '话题排序',
      topicUp: '上传地区',
      languageAr: '阿拉伯语区',
      languageEn: '英语区',
      languageY: '印尼语区',
      languageTr: '土耳其语区',
      sortNeetNum: '话题排序的格式应为数字',
      titleNotNull: '话题名称不能为空',
      imageNotNull: '话题图片不能为空',
      introduceNotNull: '话题描述不能为空',
      regionNotNull: '上传地区不能为空',
      recommendTimeTo: '推荐至',
      chooseYMD: '请选择年月日',
      chooseHMS: '请选择时分秒',

      topicId: '话题id',
      topicMarkTitle: '语言区: {area}, 话题名称: {name}',
      languageArea: '语言区',
      userId: '用户ID',
      userName: '用户名称',
      postId: '帖子ID',
      postContente: 'post内容',
      pic: '图片',
      audio: '音频',
      operatUser: '操作用户',
      movePost: '移贴',
      postMoveTopic: '帖子转移到其他话题',
      topicText: '话题',
      enterWarnCode: '请填写完整通行码',
      enterTopicCode: '请选择话题',
      selectMove: '转移选中的帖子',
      pleaseSelectPost: '请先选择需要操作的帖子',
      isOfficial: '是否为官方话题',
      warnNum: '数值不能大于9999999999',
      editAdmin: '编辑管理员',
      addAdminId: '添加管理员id',
      nowTopicAdmin: '当前话题管理员',
      topicAdmin: '话题管理员',
      addTopicWarn: '确认添加该用户为话题管理员?',
      deleteTopicWarn: '确认删除该话题管理员?',
      editTopicType: '编辑话题大类',
      setTopic: '设置分区/大类',
      editTopic: '修改话题大类',
      addTypeTitle: '添加话题分类',
      editTypeTitle: '修改话题分类',
      addTypeForm1: '添加地区',
      addTypeForm2: '添加话题分类',
      addTypeForm2_1: '添加话题大类',
      addTypeForm3: '修改话题分类',
      typeListTitle: '当前语区为: ',
      table2Text1: '排序',
      table2Text2: '话题类别',
      table2Text3: '语区',
      table2Text4: '状态',
      statusWarnText1: '确认执行上架操作',
      statusWarnText2: '确认执行下架操作',
      addTypeForm4: '添加话题类别名称',
      addTypeForm5: '话题类别排序',
      statusWarnText3: '话题分类填写不能为空',
      statusWarnText4: '确认添加该话题分类',
      statusWarnText5: '确认修改该话题分类',
      statusWarnText6: '话题类别名称不能超过120字',
      placeholder1: '请输入话题名称',
      topicName1: '话题类别名称(英)',
      topicName2: '话题类别名称(阿)',
      topicName3: '话题类别名称(印)',
      topicName4: '话题类别名称(土)',
      topicName5: '话题类别名称(西)',
      topicName6: '话题类别名称(越)',
      selectWarn1: '请选择上线区域',
      tab2text1: '话题大类',
      tab2text2: '创建人',
    },
    topicReview: {
      search1: '分区',
      search2: '分类',
      search3: '用户id',
      search4: '待审核',
      search5: '拒绝',
      search5_1: '已删除',
      search6: '状态',
      tab1: '未审核',
      tab2: '已审核',
      tableText1: '语言区',
      tableText2: '话题分类',
      tableText3: '用户id',
      tableText4: '用户名称',
      tableText5: '话题名称',
      tableText6: '话题介绍',
      tableText7: '话题图片',
      tableText8: '申请时间',
      tableText9: '操作人员',
      tableText10: '操作时间',
      tableText11: '用户国家',
      tableText12: '批量删除',
      tableText13: '批量通过',
      tableText16: '批量拒绝',
      tableText14: '社区禁言&拒绝',
      tableText15: '封禁id&拒绝',
      warnText1: '确认执行通过操作',
      warnText2: '确认执行拒绝操作',

      btnText1:'警告后拒绝',
      btnText2:'禁止发帖',
    },
    postPermiss: {
      checkAdmin: '是否校验超管',
      checkNoble: '是否校验贵族',
      checkLevel: '任意等级>=',
      levelWarn: '等级需要填写数字',
    },
    contentReview: {
      chooseLanguage: '请选择语言区',
      choosePost: '请选择post状态(默认为空)',
      chooseUserId: '请输入用户ID',
      languageArea: '语言区',
      languageAr: '阿拉伯语区',
      languageEn: '英语区',
      languageY: '印尼语区',
      languageTr: '土耳其语区',
      userId: '用户ID',
      nickname: '用户名称',
      topicName: '话题名称',
      postContent: 'post内容',
      votingOptionsContent: '投票选项内容',
      topicImg: '图片',
      audio: '音频',
      createTime: '创建时间',
      commentAndGood: '评论数/点赞数',
      commentsNum: '评论数',
      goodNum: '点赞数',
      operaUser: '操作用户',
      recommend: '推荐',
      shield: '屏蔽',
      search: '搜索',
      wait: '待审核',
      process: '审核通过',
      notPassed: '审核不通过',
      pleaseChoose: '请选择',
      unrecommend: '不推荐',
      shenPost: '沉贴',
      shenPosted: '已沉贴',
      unshield: '解除屏蔽',
      recommended: '已推荐',
      systemRecome: '系统推荐',
      shielded: '已屏蔽',
      cancalShielded: '取消屏蔽',
      deleted: '已删除',
      postId: '帖子id',
      seeType: '可见类型',
      visibleToAll: '所有人可见',
      followSee: '关注即可见',
      mutualVisible: '互相关注可见',
      private: '私人，仅po主可见',
      topText: '置顶',
      chooseTopTime: '选择置顶时间',
      pleaseChooseTime: '请选择时间',
      pleaseEnterTime: '请输入置顶时间',
      topTimeTo: '置顶至{time}',
      checkCancelTop: '确认取消置顶',
      privatePost: '私人帖子不可修改',
    },
    // 年度盛典
    annualCeremony: {
      postId: '帖子ID',
      topicId: '话题ID',
      topicTitle: '话题名称',
      topicContent: '帖子内容',
      topicImg: '帖子图片',
      topicVoice: '语音',
      seconds: '秒数',
      sort: '排序',
      create_time: '添加时间',
      addPost: '添加精选',
      sortText: '数字越大越前面',

      topicNotNull: '帖子id需要为数字且不能为空',
      sortNotNull: '排序需要为数字且不能为空',
      editPost: '编辑精选',
      checkDelPost: '确认删除这条精选帖子',
    },
    reportManagement: {
      postReport: 'post举报',
      commentReport: '评论举报',
      fuseList: '评论熔断列表',
      postFuseList: 'post熔断列表',
      pleaseChoose: '请选择语言区',
      pleaseUserId: '请输入用户ID',
      languageArea: '语言区',
      languageAr: '阿拉伯语区',
      languageEn: '英语区',
      languageY: '印尼语区',
      languageTr: '土耳其语区',
      userId: '用户ID',
      username: '用户名称',
      topicName: '话题名称',
      postContent: '内容',
      commentContent: '评论内容',
      image: '图片',
      audio: '音频',
      reportTime: '最早举报时间',
      reportNum: '举报次数',
      reporterId: '举报人id',
      status: '状态',
      operater: '操作人员',
      // ignore: '忽略',
      ignore: '检查通过',
      shield: '屏蔽',
      // ignored: '已忽略',
      ignored: '已检查通过',
      shielded: '已屏蔽',
      cancelShield: '取消屏蔽',
      deleted: '已删除',
      mute: '禁言',
      muted: '已禁言',
      unMute: '解除禁言 禁言到期时间: {date}',
      operatRole: '操作人角色',
      role1: '审核人员',
      role2: '超管',
      role3: '后台管理员',
      role4: '国家管理员',
      showBigImg: '查看大图',
      operatTime: '操作时间',
      checkCancelShield: '确认执行取消屏蔽操作',

      deleteAndBan:'删除并禁言',
      deleteAndBanId:'删除并封禁ID',
      batchDelete:'批量删除',
      batchIgnore:'批量忽略',
      pleaseChooseContent:'请选择内容',
      sureAction:'确认对所选项目进行 {action}吗',
    },

    auditorManagement: {
      auditStatistics: '审核统计',
      auditMemberManage: '审核人员管理',
      auditId: '审核人员ID',
      yesterdayAudit: '昨日审核数',
      weekAuditNum: '本周审核数',
      lastWeekAuditNum: '上周审核数',
      monthAuditNum: '本月审核数',
      lastMonthAuditNum: '上月审核数',
      addAuditId: '新增审核人员id',
      forLanguageArea: '负责语言区',
      languageAr: '阿拉伯语',
      languageEn: '英语',
      languageY: '印尼语',
      languageTr: '土耳其语',
      auditMem: '审核人员',
      languageArea: '语言区',
      enterAuditId: '请输入审核人员ID',
      chooseLanguage: '请选择服务语言(可多选)',
      auditModalTitle: '审核人员管理',
      userIdNotNull: '审核人员id不能为空',
      enterUserId: '请输入用户靓号id',
      userId: '用户靓号',
      region: '区域',
      text1:'昨日审核数',
      text2:'本周审核数',
      text3:'上周审核数',
      text4:'本月审核数',
      text5:'上月审核数',
      text6:'',
    },

    communityAnomaly: {
      resetData: '重置资料',
      banId: '封禁id',
      banDevice: '封禁设备',
      // ignore: '忽略',
      ignore: '检查通过',
      enterUserId: '请输入用户靓号id',
      mute: '禁言',
      muted: '已禁言',
      unMute: '解除禁言',
      tabText1: '社区异常记录',
      tabText2: '封禁记录',
      enterIdInvalid: '输入的id无效',
      userId: '用户靓号',
      inTotal: '共有{num}个账号',
      ignoreText: '确认忽略举报信息？',
      userIdText: '用户ID',
      oneMinComment: '1分钟评论次数',
      userLevel: '用户等级',
      registerTime: '注册时间',
      registerIp: '注册ip',
      country: '国家',
      clickShowText: '点击查看',
      operatTime: '操作时间',
      operatContent: '操作内容',
      operaUser: '操作人',
      // ignored: '已忽略',
      ignored: '已检查通过',
      ban12hed: '已封禁广播12h',
      banDeviced: '已封禁设备',
      banIded: '已封禁id',
      reseted: '已重置资料',
      contentList: '回复内容列表',
      contentDelAll: '全部删除',
      replyContent: '回复内容',
      choose: '选择',
      delSelect: '删除选中回复',
      delSelectCheck: '确认删除选中回复',
      deleted: '已删除',
      status: '状态',
      muteAlreadyOut: '禁言已解除',
      muteTime: '禁言到期时间',
    },
    statistics: {
      contentStatistics: '社区内容统计',
      userStatistics: '社区用户行为统计',
      interactivePosts: '社区互动帖子统计',
      // 社区内容数据统计
      date: '日期',
      postedNum: '发布帖子数量',
      interactiveNum: '有互动帖子数量',
      likesNum: '有点赞帖子数量',
      commentsNum: '有评论帖子数量',
      sharedNum: '有分享帖子数量',
      topicNum: '带话题帖子数量',
      hasVoiceNum: '含语音帖子数量',
      hotPostNum: '热门帖子数量',
      // 社区用户行为统计
      activeUser: '广场活跃用户数',
      userPostNum: '发布帖子用户数',
      joinLinkNum: '参与点赞用户数',
      userCommentNum: '参与评论用户数',
      userLinkNum: '用户点赞次数',
      userShareNum: '用户评论次数',
      userShare: '用户分享次数',
      region: '地区',
      allData: '汇总',
      // 社区互动帖子统计
      oneDay: '第一天',
      twoDay: '第二天',
      threeDay: '第三天',
      fourDay: '第四天',
      fiveDay: '第五天',
      sixDay: '第六天',
      sevenDay: '第七天',
      startGtEnd: '开始时间不能大于结束时间',
      numberOfPosts: '带投票帖子数',
      numberOfUsers: '参与投票用户数',
    },
    broadcastManagement: {
      enterId: '请输入用户靓号id',
      userLiangId: '用户靓号',
      areaSearch: '地区搜索',
      tabText1: '已审核',
      tabText2: '未审核',
      // ignore: '忽略',
      ignore: '检查通过',
      ban12h: '封禁广播12h',
      banBtn: '封禁广播',
      banDevice: '封禁设备',
      banId: '封禁ID',
      selectAll: '全选',
      choose: '选择',
      country: '国家',
      userId: '用户ID',
      username: '用户昵称',
      broadcastContent: '广播内容',
      operaTime: '操作时间',
      sendTime: '发布时间',
      operaer: '操作人',
      operatContent: '操作内容',
      // ignored: '已忽略',
      ignored: '已检查通过',
      deleted: '已删除',
      ban12hed: '已封禁广播12h',
      banBtned: '已封禁广播',
      banDeviced: '已封禁设备',
      banIded: '已封禁id',
      araArea: '阿语区',
      enArea: '英语区',
      turArea: '土耳其区',
      indArea: '印尼语区',
      level: '等级',
      registraTime: '注册时间',
      registerIp: '注册IP',
      inTotal: '共有{num}个账号',
      selectText1: '广播',
      selectText2: '粉丝召集',
      selectText3: '成员召集',
      selectText4: '公会召集',
      selectText5: '未审核',
      selectText6: '已审核',
      selectText7: '已删除',
      convenedContent: '召集内容',
      area: '区域',
      table1Text1: '审核昵称',

      table1Text2: '等待时长',
      table1Text3: '审核时间',
      table1Text4: '审核人ID',
    },

    avatarReview: {
      userLiangId: '用户靓号',
      pleaseEnterId: '请输入用户靓号id',
      tabText1: '头像审核',
      tabText2: '违规记录',
      pass: '通过',
      // ignore: '忽略',
      ignore: '检查通过',
      reset: '重置资料',
      banId: '封禁id',
      selectAll: '全选',
      banDevice: '封禁设备',
      totalCount: '共有{num}个账号',
      showBigImg: '查看大图',
      // ignored: '已忽略',
      ignored: '已检查通过',
      reseted: '已重置资料',
      banDeviced: '封禁设备',
      banIdTo: '封禁id',
      resetTime: '重置时间',
      auditor: '操作人',
    },
    albumReview: {
      pageText1: '头像审核',
      status: '状态',
      pageText2: '批量通过',
      pageText3: '批量拒绝',
      pageText4: '确认执行通过操作?',
      pageText5: '确认执行拒绝操作?',
      pageText6: '待审核',
      pageText7: '已审核',
      pageText8: '已拒绝',
      pageText9: '违规处理',
      pageText10: '忽略记录',

      pageText11:'确认执行警告后删除吗？',
      pageText12:'确认禁止发帖吗？',
    },

    reviewDetail: {
      choose: '选择',
      registerUser: '注册用户',
      nickname: '昵称',
      country: '国家',
      deviceCode: '设备码',
      wealth: '财富',
      charm: '魅力',
      activeLevel: '活跃等级',
      registerIp: '注册ip',
      regisTime: '注册时间',
      lastLoginTime: '最后登录时间',
      userId: '用户id',
      pleaseEnterId: '请输入用户ID',
      chooseAll: '全选',
      reset: '重置资料',
      banId: '封禁id',
      banDevice: '封禁设备',
    },
    cstStatistics: {
      enterSearchId: '请输入ID查询',
      startTime: '开始时间',
      endTime: '结束时间',
      nickname: '昵称',
      answer: '反馈回复',
      idReview: 'ID审核',
      activeReview: '活动审核',
      bgReview: '房间背景审核',
      banRecord: '封禁记录',
      pass: '审核通过',
      refuse: '拒绝通过',
      banId: '封禁ID',
      banDevice: '封禁设备',
      adminGroup: '管理员分组',
    },
    omtStatistics: {
      enterSearchId: '请输入ID查询',
      startTime: '开始时间',
      endTime: '结束时间',
      nickname: '昵称',
      BrManage: '广播管理',
      avatarReview: '头像审核',
      machineReport: '机器举报',
      userReport: '用户举报',
      banRecord: '封禁记录',
      pass: '审核通过',
      refuse: '拒绝通过',
      banId: '封禁ID',
      banDevice: '封禁设备',
      adminGroup: '管理员分组',

      Photoalbumreview: '相册审核',
      Backgroundmanagement: '背景管理',
      Activitiestoapplyfor: '活动申请',
    },
    operationLog: {
      // enterSearchId: '请输入需要查询的用户ID',
      operator: '操作人id',
      operater: '用户id',
      operaterRoomLabel: '房间id',
      operaterRoom: '被操作房间id',
      enterOperaterId: '请输入用户id',
      enterOpertaterRoom: '请输入房间id',
      searchUser: '查用户',
      searchRoom: '查房间',
      searchType: '搜索类型',


      enterSearchId: '请输入操作人id查询',
      enterIdInvalid: '输入的id无效',
      startTime: '开始时间',
      endTime: '结束时间',
      date: '日期',
      adminId: '管理员id',
      adminName: '管理员名称',
      operatModule: '操作模块',
      operaContent: '操作内容',
      reason: '原因',
      module1: '用户信息查询',
      module2: '广播管理',
      module3: '头像审核',
      module4: '机器举报',
      module5: '用户举报',
      module6: 'ID审核',
      module7: '活动审核',
      module8: '房间背景审核',
      module9: '前端模块',
      module10: '申诉大厅',
      module11: '社区异常操作上报',
      module12: '房间查询',
      module13: '客服知识库',
      module14: '客服账号管理',
      module15: '问题库',
      module16: '家族信息查询',
      module17: '发帖权限',
      module18: '话题管理',
      module19: '帖子审核',
      module20: '举报管理',
      module21: '审核人员管理',
      module22: '管理员',
      module23: '账号黑名单管理',
      module24: '管理员账号',
      module25: '角色权限',
      module26: '话题审核',
      module27: '相册审核',
    },
    operateType: {
      // 封禁id，2解禁id,3封禁设备，4解禁设备，5封禁广播，6修改靓号，7重置资料，8通过,9拒绝,10反馈回复
      banId: '封禁id',
      unbanId: '解禁id',
      banDevice: '封禁设备',
      unbanDevice: '解禁设备',
      banBroad: '封禁广播',
      updateId: '修改靓号',
      reset: '重置资料',
      pass: '审核通过',
      refuse: '拒绝通过',
      answer: '反馈回复',
      delete: '删除',
      banRoom: '封禁房间',
      unBanRoom: '解禁房间',
      resetRoomInfo: '重置房间信息',
      unBanBoard: '解禁广播',
      updateOrAdd: '修改/添加',
      updateRoomBasic: '修改房间基本信息',
      updateUserInfo: '修改用户信息',
      updateFamilyInfo: '修改家族基本信息',
      dropOff: '上/下架',
      recommendedPosts: '推荐帖子',
      blockPosts: '屏蔽帖子',
      mute: '禁言',
      unMute: '解除禁言',
      upDateRoomId: '修改房间靓号',
    },
    nowMemberInroom: {
      enterId: '请输入用户靓号id',
      userId: '用户靓号',
      enterRoomTime: '进入房间时间',
      roomId: '房间靓号',
    },
    loginFeedback: {
      date: '日期',
      desc: '描述',
      contact: '联系信息',
      imgOrVideo: '图片或视频',
      equipment: '设备型号',
      system: '版本系统',
      version: '版本号',
      showDetail: '查看详情',
      enterStartAndEnd: '请填入开始时间还有结束时间',
    },
    systemBlacklist: {
      userIPBlack: '用户IP黑名单',
      addBlack: '新增黑名单用户',
      userBlack: '用户黑名单',
      refuseLog: '拒绝服务日志',
      errorLogin: '异常注册记录',
      lastId: '最后活跃ID',
      loginNum: '注册账号数',
      phoneLogin: '手机号注册数',
      fbLogin: 'FB注册数',
      gugeLogin: '谷歌注册数',
      refuseNum: '拒绝服务次数',
      lastRefuseTime: '最后拒绝服务时间',
      addTime: '添加日期',
      pleaseEnter: '请输入通行码以完成新增',
      delUser: '删除黑名单用户:{name}',
      passNum: '通行码',
      enterPassNum: '请输入通行码以完成操作',
      enterWarnText: '请填写完整ip和通行码',
      enterWarnIp: '请填写完整IP',
      enterWarnCode: '请填写完整通行码',
      refuseId: '拒绝服务ID',
      refuseTime: '拒绝服务时间',

      loginNum24: '24h注册账号数',
      phoneLogin24: '24h手机号注册数',
      fbLogin24: '24hFB注册数',
      gugeLogin24: '24谷歌注册数',
      addToBlack: '添加到黑名单',
    },
    activitySupport: {
      search1Text1: '每日',
      search1Text2: '每周',
      search1Text3: '每月',
      type: '类型',
      roomNumber: '房间靓号',
      tableText1: '日期',
      tableText2: '扶持房间数量',
      tableText3: '扶持场次',
      tableText4: '活动流水',
      tableText5: '活动礼物扶持价值',
      tableText6: '扶持占比',
      tableText7: '活动ROI',
      tableText8: '未达标扶持占比',
      tableText9: '单场50W以上流水的场次',
      tableText10: '单场50W以上的流水',
      tableText11: '流水占比',
      tableText12: '5W-50W场次',
      tableText13: '5W-50W流水',
      tableText14: '流水占比',
      tableText15: '5W以下场次',
      tableText16: '5W以下流水',
      tableText17: '流水占比',
      tableText18: '未达标扶持占比',
    },
    couplePage: {
      table1Text1: '活动类型',
      table1Text2: '活动标题',
      table1Text3: '图标',
      table1Text4: 'url',
      table1Text5: '区域',
      table1Text6: '开始时间',
      table1Text7: '结束时间',
      table1Text8: '创建时间',
      table1Text9: '后台管理员',
      search1Text1: '房间',
      search1Text2: 'CP',
      search1Text3: '活动类型',
      search1Text4: '点击上传图片',
      search1Text5: '清除',
      search1Text6: '周星周cp类型',
      search1Text7: '旧周星',
      search1Text8: '新周星',
      search1Text9: '周cp',
      search1Text10: '请输入管理员id',
      errorMsg1: '请填写完整',
      errorMsg2: '请上传图标',
      errorMsg3: '请选择开始时间和结束时间',
      errorMsg4: '确认删除这条数据',
    },
    gameStatistics: {
      game: '游戏',
      area: '区域',
      country: '国家',
      gameAll: '对局总量',
      gameStatus: '对局状态',
      noRun: '无逃跑',
      openNum: '开局人数',
      peopleNum: '人数占比',
      complateGame: '完成比赛',
      percent: '占比',
      cancel: '主动取消',
      timeOver: '超时取消',
      numText: '数量',
      game2: '2人局',
      game3: '3人局',
      game4: '4人局',
      areaText1: '海湾地区',
      areaText2: '土耳其地区',
      areaText3: '其他地区',
      overGameNum: '完局人数',
      warDrum: '战鼓',
      game5: '2-4人局',
      game6: '5-8人局',
      game7: '9-10人局',
    },

    groupReview:{
      groupID:'群ID',
      banGroup:'封禁群组',
      banOwner:'封禁群主',
      checkPending:'待审核',
      checkPass:'审核通过',
      resetData:'重置资料',
      operaTime:'操作时间',
      warningMsg:'警告',

      text:'请输入群组ID/群主ID',
      tabText1:'群组举报列表',

      banReason:'封禁原因',
      banText:'内容',
      ownerId:'群主ID',
      userCount:'群人数',
      groupName:'群名称',
      avatar:'群头像',
      introduction:'群介绍',
      blackList:'黑名单',

      banAction:'封禁',
      unBan:'解除封禁',
      addTime:'创建时间',
      btnText1:'查看详情',
      btnText2:'踢出群组',
      reset:'重置资料',
      normal:'正常',
      permanentBan:'永久封禁',

      identity:'身份',
      tableText5:'发言次数',
      tableText6:'群流水',
      title1:'群组成员列表',

      disBandGroup:'解散群组',
      disBand:'解散',


    },

    // 房间专栏
    roomColumn: {
      bannerImg: "banner图",
      tabText1: "房间banner",
      tabText2: "banner申核",
      tabText3: "发现页banner",
      table1Text1: "排序",
      table1Text2: "英语",
      table1Text3: "阿语",
      table1Text4: "西语",
      table1Text5: "土耳其语",
      table1Text6: "印地语",
      table1Text7: "越南语",
      table1Text8: "泰语",
      table1Text9: "印尼",
      table1Text10: "葡萄牙语",
      table1Text11: "下架时间",
      table1Text12: "封面图",
      table1Text13: "大图",
      table1Text14: "房间",
      table1Text15: "已上架",
      table1Text16: "未上架",
      table1Text17: "区域",
      table1Text18: "下架",
      table1Text19: "上架",
      table1Text20: "上下架时间",
      table1Text21: "上架时间",
      table1Text22: "下架时间",
      table1Text23: "注意：输入1代表在这个地区,不显示标题。",
      table1Text24: "专栏名称(英语)",
      table1Text25: "专栏名称(阿语)",
      table1Text26: "专栏名称(西语)",
      table1Text27: "专栏名称(土耳其语)",
      table1Text28: "专栏名称(印地语)",
      table1Text29: "专栏名称(越南语)",
      table1Text30: "专栏名称(泰语)",
      table1Text31: "专栏名称(印尼语)",
      table1Text32: "专栏名称(葡萄牙语)",
      table1Text33: "外图",
      table1Text34: "内图",
      table1Text35: "Banner跳转类型",
      table1Text35_1: "跳转类型",
      table1Text36: "H5",
      table1Text37: "帖子",
      table1Text38: "话题",
      table1Text39: "内图房间ID",
      table1Text40: "URL",
      table1Text41: "话题id/帖子id",
      table1Text42: "排序",
      table1Text43: "上架时间",
      table1Text44: "下架时间",
      table1Text45: "每天上架时间",
      table1Text46: "每天下架时间",
      table1Text47: "新增并复制关联功能",
      table1Text48: "请选择类型",
      table1Text49: "内图图片绑定ID",
      table1Text50: "H5链接",
      table1Text51: "请输入每天上架时间",
      table1Text52: "请输入每天下架时间",
      table1Text53: "排序输入框不能为空",
      table1Text54: "外图不能为空",
      table1Text55: "房间",
      table1Text56: "活动详情",
      table1Text58: "申请人ID",
      table1Text59: "印度区",

      table2Text57: "国籍",
      table2Text58: "房间ID",
      table2Text59: "房主ID",
      table2Text59_1: "申请人ID",
      table2Text60: "活动名称",
      table2Text61: "活动开始时间",
      table2Text62: "活动持续时长",
      table2Text63: "活动描述",
      table2Text64: "社媒账号",
      table2Text65: "社媒截图",
      table2Text66: "Banner截图",
      table2Text67: "banner申请地区",
      table2Text68: "小时",
      table1Text69: "确认执行上架操作",
      table1Text70: "确认执行下架操作",
      table1Text71: "上下架操作",
      table1Text72: "上架时间",
      table1Text73: "下架时间",
      table1Text74: "上架时间或者下架时间不能为空",
      table1Text75: "确认执行删除操作",
      table2Text76: "确认执行通过操作",
      table2Text77: "确认执行拒绝操作",
      table2Text78: "拒绝理由",

      table1Text78: "URL",
      table1Text79: "帖子id",
      table1Text80: "话题id",
      table1Text81: "房间id",
      table1Text82: "活动id",
      table1Text83: "请填写拒绝理由",
      table1Text106: "群id",

      table1Text84: "Banner URL/规则URL",
      table1Text85: "Banner 房间靓号/话题id/帖子id",
      table1Text86: "是否允许用户申请",
      table1Text87: "每天上架时间",
      table1Text88: "每天下架时间",
      table1Text89: "专栏房间列表",
      table1Text90: "认证级别",
      table1Text91: "本月扶持活动场次",
      table1Text92: "房间活动",
      table1Text93: "专栏活动",
      table1Text94: "图片尺寸不符合",
      table1Text95: "扶持活动",
      table1Text96: "专栏扶持活动",
      table1Text97: "添加banner",
      table1Text98: "添加专栏",
      table1Text99: "编辑banner",
      table1Text100: "编辑专栏",

      table1Text101: "即将上架",
      table1Text102: "申请人ID",
      table1Text103: "申请人ID或后台账号名",
      table1Text104: "上架房间",
      table1Text105: "已下架房间",


      table2Text1: "相亲 ",
      table2Text2: "板球",
      table2Text3: "电影秀",
      table2Text4: "脱口秀",
      table2Text5: "音乐",
      table2Text6: "幸运儿",
      table2Text7: "冲顶",
      table2Text8: "婚礼",
      table2Text9: "生日",
      table2Text10: "单身派对",
      table2Text11: "Banner专栏类型",
      table2Text12: "房间列表",

      table2Text13: "内图跳转类型",
      table2Text14: "内图 URL/规则URL",
      table2Text15: "内图 房间靓号/话题id/帖子id",
      table2Text16: "宾果游戏",
      table2Text17: "才艺秀",
      table2Text18: "诗歌",
      table2Text19: "猜谜",
      table2Text20: "房间专栏",

      //

      batchPass:'批量通过',
      batchReject:'批量拒绝',
      batchDelete:'批量删除',

      reviewedBy:'审核人',
      reviewedTime:'审核时间',
      waitingTime:'等待时长',

    },
    auditManageBg: {
      roomLiangId: "房间靓号",
      status: "状态",
      allAudit: "所有审核",
      unAudit: "未审核",
      audited: "已审核",
      roomNum: "房间号",
      roomBg: "背景",
      auditPass: "审核通过",
      refused: "被拒绝",
      checkPass: "确认执行通过操作",
      checkRefuse: "确认执行拒绝操作",
      writeReason: "填写理由",
      checkBatchPass: "确认执行批量通过操作",
      checkBatchRefuse: "确认执行批量拒绝操作",
      batchPass: "批量通过",
      batchRefuse: "批量拒绝",
      toBeAudit:'待审核',
    },
  },
  components: {
    banModal: {
      chooseTime: '选择封禁时间',
      chooseReason: '选择原因',
      content: '举报内容：',
      enterContent: '可输入举报内容',
      enterUrl: '可输入图片或视频链接',
      imgVideoUrl: '图片或视频链接：',
      // banUser: '确认封禁该用户？',
      banUser: '确认执行封禁操作？',
      ban24: '封禁24小时',
      ban72: '封禁72小时',
      ban30D: '封禁30天',
      permanentBan: '永久封禁',

      banReason:'封禁原因',
      enterReason:'输入原因',

      target:'封禁对象',
    },
    loginForm: {
      enterUserName: '请输入用户名',
      enterPassword: '请输入密码',
      login: '登录',
      accountNotNone: '账号不能为空',
      passwordNotNone: '密码不能为空',
    },
    fullScreen: {
      exitScreen: '退出全屏',
      fullScreen: '全屏',
    },
    headerBar: {
      title: 'StarChat 多国服务系统V3.3',
    },
    tagsNav: {
      closeAll: '关闭所有',
      closeOther: '关闭其他',
    },
    user: {
      signOut: '退出登录',
    },
    publicCheckPassword: {
      checkPassword: '输入操作密码，并确认',
      checkSuccess: '校验成功',
    },
    publicCheckBan: {
      checkBan: '安全校验',
      checkError: '校验错误',
      checkSuccess: '校验成功',
      nameNotNull: '填写不能为空',
      enterUserName: '请输入用户名校验',
    },
    tableBox: {
      noneData: '暂无数据',
    },
    tableSearch: {
      search: '查询条件',
    },
  },
  js: {
    request: {
      systemError: '服务器系统内部错误',
      unLogin: '未登录',
      timeOut: '请求超时',
      unknownMis: '未知错误',
      linkError: '网络连接失败',
      requestServerError: '请求服务器失败，请重试',

      postRemove: '帖子已被删,不可以此操作',
      commentRemove: '评论已被删,不可以此操作',
      postUnExist: '帖子不存在',
      commentUnExist: '评论不存在',
      postUnOpera: '帖子已做忽略或屏蔽或删除的操作,不能再操作',
      commentUnOpera: '评论已做忽略或屏蔽或删除的操作,不能再操作',
    },
  },

  home: {
    test: "测试"
  },

}



// WEBPACK FOOTER //
// ./src/language/zh-cn.js